import { ISessionInfo } from '@inrupt/solid-client-authn-core'
import log from 'loglevel'

export const getAggregateUrl = (path: string) => {
  const aggServiceHost = process.env.REACT_APP_AGGREGATION_SERVICE
  if (!aggServiceHost) {
    const msg = 'No environment variable set for AGGREGATION_SERVICE'
    log.error(msg)
    throw new Error(msg)
  }
  return `${aggServiceHost}${path}`
}

export const fetchAuthenticated = <T>(
  url: string,
  init?: RequestInit
): Promise<T> => {
  return fetch(url, {
    credentials: 'include',
    ...init,
  }).then(res => {
    if (!res.ok) {
      return res.text().then(t => Promise.reject(new Error(t)))
    }
    return res.json()
  })
}

export const fetchAuthenticatedVoid = (
  url: string,
  init?: RequestInit
): Promise<void> => {
  return fetch(url, {
    credentials: 'include',
    ...init,
  }).then(res => {
    if (!res.ok) {
      return res.text().then(t => Promise.reject(new Error(t)))
    }
  })
}

export const fetchSessionInfo = (): Promise<ISessionInfo | undefined> => {
  return fetchAuthenticated<{
    isLoggedIn: boolean
    sessionInfo: ISessionInfo | undefined
  }>(getAggregateUrl(`/session-info`), {
    method: 'GET',
  })
    .then(res => {
      return res.sessionInfo
    })
    .catch(err => {
      return undefined
    })
}

export const logoutServer = (): Promise<void> => {
  return fetchAuthenticatedVoid(getAggregateUrl('/logout'), { method: 'GET' })
}

export const fetchByServer: typeof window.fetch = (requestInfo, init) => {
  log.debug({ requestInfo, init })
  return fetch(getAggregateUrl(`/fetch`), {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ requestInfo, init }),
  })
}
